import axios from 'axios';

export class CommonAPIService {
  constructor() {
    this.api_url = process.env.VUE_APP_API_URL;
    this.loggedIn = false;
  }

  // main login method for the code
  login(login, router, store, errors) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    return axios.post(`${this.api_url}/api/auth/login`, login)
      .then((response) => {
        localStorage.setItem('jwtToken' + '', response.data.token);
        // store.dispatch('ADD_USERID', response.data.user.id);
        store.setUsername(response.data.user.username);
        store.setScopes(response.data.user.auth_groups);
        store.setLoggedIn(true);
        return response.data;
      })
      .catch((e) => {
        errors.push(e);
        if (e.response.status === 401) {
          router.push({
            name: 'login',
          });
        }
        return {success: false, msg: 'Login Failure'};
      });
  }

  postCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    axios.defaults.timeout = 100000;
    const fullUrl = this.api_url + url;
    parameters.timeout = 100000;
    return axios.post(fullUrl, parameters)
      .then((response) => {
        // console.debug('postCall response', response);
        return response.data
      })
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: 'login',
          });
        }
        throw error
      });
  }

  fileCall(url, files, router) {
    const fullUrl = this.api_url + url;
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    return axios({
      method: 'get',
      url: fullUrl,
      responseType: 'blob',
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401) {
        router.push({
          name: 'Login',
        });
      }
      throw error;
    });
  }

  deleteCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    const fullUrl = this.api_url + url;
    axios.defaults.timeout = 100000;
    return axios.delete(fullUrl, parameters)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          router.push({
            name: 'Login',
          });
        }
        throw error;
      });
  }

  putCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    axios.defaults.timeout = 100000;
    const fullUrl = this.api_url + url;
    return axios.put(fullUrl, parameters)
      .then(response => response.data)
      .catch((error) => {
        if (error.response.status === 401) {
          router.push({
            name: 'Login',
          });
        }
        throw error;
      });
  }

  getCall(url, parameters, router) {
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    axios.defaults.timeout = 100000;
    const fullUrl = this.api_url + url;
    return axios.get(fullUrl, parameters)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          router.push({
            name: 'Login',
          });
        }
        throw error;
      });
  }
   newFileCall(url, formData) {
    const fullUrl = this.api_url + url;
    axios.defaults.headers.common.Authorization = localStorage.getItem('jwtToken');
    axios.post(fullUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      // handle the response data
      return response;
    })
    .catch(error => {
      return error;
    });
  }
}

export default CommonAPIService;
